import { forwardRef } from 'react';
import { ICellEditorParams } from 'ag-grid-community';
import { DropDownMenuItem } from '../DropdownMenu';
import SharedAutoCompleteCellRender, { SharedAutoCompleteCellRenderRef } from '../SharedAutoComplete/SharedAutoCompleteCellRender';
import styles from './autoCompleteCellRender.module.css';

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface AutoCompleteCellRenderProps<T=any> extends ICellEditorParams {
  label: string,
  options: DropDownMenuItem<T>[]
  onSelect: (row: T, selected: T) => void,
  onTextInput?: (row: T, value: string) => void
  onBlur?: () => void
  onBlurSetTextAsSelected?: boolean
  onRemove?: (index: number) => void
}

export default forwardRef<SharedAutoCompleteCellRenderRef, AutoCompleteCellRenderProps>((props, ref) => (
  <div className={styles.container}>
    <label className={styles.label}>{props.label}</label>
    <div className={styles.autoCompleteContainer}>
      <SharedAutoCompleteCellRender
        ref={ref}
        value={props.value}
        stopEditing={props.stopEditing}
        options={props.options}
        onSelect={props.onSelect}
        onTextInput={props.onTextInput}
        onBlur={props.onBlur}
        onBlurSetTextAsSelected={props.onBlurSetTextAsSelected}
        rowIdentifier={props.rowIndex}
        popperZIndex={9999}
      />
    </div>
    {props.onRemove && (
      <img
        className={styles.removeIcon}
        src="/images/CloseMidGray.svg"
        alt="remove-name-item"
        onClick={() => props.onRemove?.(props.rowIndex)}
      />
    )}
  </div>
));
